import React, { useEffect } from "react";
import { renderMathml } from "@pearsontechnology/bronte-lib-math/readonly";
import type { SingleSpaSchema } from "../types";

type SpaPluginActivityChromeProps = {
  schema: NonNullable<SingleSpaSchema>;
  componentId: string;
  spaPluginTargetItemElId: string;
  children: React.ReactNode;
};

/**
 * Rich-text shell (label, title, instructions, parcel region, captions, credit) — matches legacy SPAPluginSchemaWrapper.
 */
export const SpaPluginActivityChrome: React.FC<SpaPluginActivityChromeProps> = ({
  schema: { activityLabel, activityTitle, instructions, captions, credit },
  componentId,
  spaPluginTargetItemElId,
  children,
}) => {
  useEffect(() => {
    const el = document.getElementById(spaPluginTargetItemElId);
    if (el) {
      try {
        renderMathml(el);
      } catch {
        
      }
    }
  }, [activityLabel, activityTitle, instructions, captions, credit, spaPluginTargetItemElId]);

  return (
    <div style={{ height: "100%" }}>
      {(activityLabel || activityTitle) && (
        <h4 className="component-label-section">
          {activityLabel && (
            <span
              className="component-label"
              data-id={`${componentId}-activityLabel`}
              dangerouslySetInnerHTML={{ __html: activityLabel }}
            />
          )}
          {activityTitle && (
            <span
              className="component-title"
              data-id={`${componentId}-activityTitle`}
              dangerouslySetInnerHTML={{ __html: activityTitle }}
            />
          )}
        </h4>
      )}
      {instructions && (
        <div
          className="component-instructions"
          data-id={`${componentId}-instructions`}
          dangerouslySetInnerHTML={{ __html: instructions }}
        />
      )}
      {children}
      {captions && (
        <figcaption>
          <div
            className="component-caption"
            data-id={`${componentId}-captions`}
            dangerouslySetInnerHTML={{ __html: captions }}
          />
        </figcaption>
      )}
      {credit && (
        <div
          className="component-credit"
          data-id={`${componentId}-credit`}
          dangerouslySetInnerHTML={{ __html: credit }}
        />
      )}
    </div>
  );
};
